import { lerp } from "math";
import type { CSSProperties } from "vue";
import { globalAlerts, type IAlert } from "~/composables/useAlerts";
import { type IStackItem } from "~/composables/useIDStack";
import { useSmoothAnimation } from "~/composables/useSmoothAnimation";

const ALERT_ANIMATION_DURATION = 0.45;

const AlertWrapper = defineComponent<{ item: IStackItem<IAlert> }>((props) => {
  const bodyContent = computed(() => {
    const content = unref(props.item.body);
    if (typeof content === 'function') return <content/>;
    return content;
  })
  
  return () => {
    return <div class="w-full h-full" style={{ pointerEvents: 'all' }}>
      { bodyContent.value }
    </div>;
  }
}, { props: ['item'] })


export const AlertContainer = defineComponent(() => {
  const hook = globalAlerts; 

  const animation = useSmoothAnimation();

  const hasAlerts = computed(() => hook.count.value > 0);

  watch(hasAlerts, (has) => {
    if (has) {
      animation.to(1.0, { duration: ALERT_ANIMATION_DURATION });
    } else {
      animation.to(0.0, { duration: ALERT_ANIMATION_DURATION });
    } 
  }, { immediate: true })

  const wrapperStyle = computed((): CSSProperties => {
    const opacity = lerp(0.0, 100.0, animation.current.value);
    
    return {
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      zIndex: 106,
      left: 0,
      top: 0,
      opacity: `${opacity}%`,
      ...(opacity <= 0.000000001 ? {
        display: 'none',
        pointerEvents: 'none'
      } : {}),
      ...(hasAlerts.value === false ? {
        pointerEvents: 'none'
      } : {})
    }
  })
  
  
  return () => {
    return <div class="flex flex-col items-center justify-center bg-white" style={wrapperStyle.value}>
      {
        hook.alerts.value.map((item) => {
          return <AlertWrapper item={item} key={`alert-${item.id}`}/>
        })
      }
    </div>;
  }
});
